import { faCircleQuestion, faUserGraduate } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Button, ButtonGroup, Col, Container, OverlayTrigger, Row, Table, Tooltip } from 'react-bootstrap';
import { useLocation, useNavigate } from 'react-router';
import DropDownSearch from '../../../../../components/DropDownSearch';
import DropDownSelect from '../../../../../components/DropDownSelect';
import { useGetAllTeachersAccessibleSchoolsMutation, useGetAllCurrentStudentsMutation } from '../../../../../features/authentication/schoolApiSlice';
import { useEffect, useState } from 'react';
import { useGetStudentCategoriesMutation, useGetAllAdminsMutation } from '../../../../../features/authentication/studentApiSlice';
import TableSkeleton from '../../../../../components/SkeletonLoader/TableSkeleton';
import AddStudentFloatingBar from '../components/addStudentFlotingBar';
import CustomToast from '../../../../../components/Toast';
import { useAddStudentMutation } from '../../../../../features/authentication/classesApiSlice';
import Modal from '../../../../../components/Modal';
import React from 'react';

const AddStudents = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const className = location.state?.selectedClass?.name;
  const classId = location.state?.selectedClass?.id;

  const [getAllSchools] = useGetAllTeachersAccessibleSchoolsMutation();
  const [getStudentCategories] = useGetStudentCategoriesMutation();
  const [getAllCurrentStudents] = useGetAllCurrentStudentsMutation();
  const [addStudentsAPI] = useAddStudentMutation();
  const [getAllAdmins] = useGetAllAdminsMutation();

  const [schools, setSchools] = useState([]);
  const [students, setStudents] = useState(null);
  const [selectedStudents, setSelectedStudents] = useState([]);
  const [categories, setCategories] = useState([]);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ'.split('');

  const [selectedSchoolId, setSelectedSchoolId] = useState(null);
  const [selectedSchoolName, setSelectedSchoolName] = useState('');
  const [searchKey, setSearchKey] = useState('');
  const [filterKey, setFilterKey] = useState('');
  const [debouncedSearchText, setDebouncedSearchText] = useState(searchKey);
  const [doneInitialLoad, setDoneInitialLoad] = useState(null);
  const [admins, setAdmins] = useState(null);
  const [openAdminHelpModal, setOpenAdminHelpModal] = useState(false);

  useEffect(() => {
    getAllSchoolsAsync();
  }, []);

  async function getAllSchoolsAsync() {
    var response = await getAllSchools().unwrap();
    setSchools(response);
    if (response.length > 0) {
      var selectedSchoolId = response.filter(x => x.selected == true).length > 0 ? response.filter(x => x.selected == true)[0] : response[0];
      await loadStudentCategories(selectedSchoolId.id);
      await loadAllStudents(selectedSchoolId.id);
      setDoneInitialLoad(true);
      setSelectedSchoolId(selectedSchoolId.id);
      setSelectedSchoolName(selectedSchoolId.name);
    }
  }

  async function loadStudentCategories(schoolId) {
    var response = await getStudentCategories(schoolId).unwrap();
    setCategories([
      ...response.map((item) => ({
        name: item.name,
        id: item.name,
      }))
    ]);
  }

  async function loadAllStudents(schoolId) {
    setStudents(null);
    const options = {
      isInClassCheckId: classId,
      searchKey: debouncedSearchText,
      filterKey: filterKey,
      categories: categories.filter(x => x.isChecked).map((item) => item.name)
    };
    const queryString = toQueryString(options);

    var response = await getAllCurrentStudents({ schoolId, queryString }).unwrap();
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
      setStudents([]);
      return;
    }
    setStudents(response.map(r => ({...r, isChecked: selectedStudents.find(s => s.studentId == r.studentId)?.isChecked ?? false})));
  }

  const toQueryString = (params) => {
    const queryParams = new URLSearchParams();

    // Add non-array parameters
    Object.keys(params).forEach(key => {
      if (Array.isArray(params[key])) {
        // Add array elements as separate parameters with the same key
        params[key].forEach(item => {
          queryParams.append(key, item);
        });
      } else {
        queryParams.append(key, params[key]);
      }
    });

    return queryParams.toString();
  };

  const handleSelectionChange = (e, filterList, setFilterList) => {
    const { key } = e;
    const selected = (key !== '000') ? filterList.find((v) => v.id == key) : filterList;
    let tempValue = [];

    if (key === '000') {
      tempValue = filterList.map((item) => ({
        ...item,
        isChecked: !filterList.filter(item => item?.isChecked !== true).length < 1,
      }));
    } else {
      tempValue = filterList.map((item) =>
        item.id == key ? { ...item, isChecked: !selected.isChecked } : item
      );
    }
    setFilterList(tempValue);
    setSelectedCategories(tempValue);
  };

  const handleSchoolChange = async (id) => {
    setSelectedSchoolId(parseInt(id));
    setCategories(null);
    setAdmins(null);
    await loadStudentCategories(parseInt(id));
    await loadAllStudents(parseInt(id));
  };

  const handleCharacterClick = (char) => {
    setFilterKey(prevKey => (prevKey === char ? '' : char));
  };

  const handleCheckBoxChange = (e) => {
    const { name, checked } = e.target;
    let modifiedStudents = [];
    let tempSelectedStudents = selectedStudents;
    if (name === 'assignCheck') {
      modifiedStudents = students.map((item) => {
        return { ...item, isChecked: !item.existsInClass ? checked : false };
      });

      if(checked){
        tempSelectedStudents = tempSelectedStudents.concat(modifiedStudents.filter(m => !m.existsInClass && !tempSelectedStudents.find(t => t.studentId == m.studentId)));
      } else {
        tempSelectedStudents = tempSelectedStudents.filter(t => !modifiedStudents.find(m => m.studentId == t.studentId));
      }
    } else if(name ==='assignCheckClipboard'){
      tempSelectedStudents = [];
      modifiedStudents = students.map((item) => ({...item, isChecked: false}));
    } else {
      const id = parseInt(name);
      modifiedStudents = students.map((item) =>
        item.studentId === id && !item.existsInClass ? { ...item, isChecked: checked } : item
      );

      if(checked && !tempSelectedStudents.find(s => s.studentId === id)){
        tempSelectedStudents.push(modifiedStudents.find(s => s.studentId === id));
      } else{
        tempSelectedStudents = tempSelectedStudents.filter(s => s.studentId != id);
      }
    }
    setStudents(modifiedStudents);
    setSelectedStudents(tempSelectedStudents);
  };

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearchText(searchKey);
    }, 500);

    return () => {
      clearTimeout(handler);
    };
  }, [searchKey]);

  useEffect(() => {
    if (doneInitialLoad)
      loadAllStudents(selectedSchoolId);
  }, [debouncedSearchText]);

  useEffect(() => {
    if (doneInitialLoad)
      loadAllStudents(selectedSchoolId);
  }, [filterKey]);

  useEffect(() => {
    if (doneInitialLoad)
      loadAllStudents(selectedSchoolId);
  }, [selectedCategories]);

  const handleAddStudent = async () => {
    if (selectedStudents.length == 0) {
      CustomToast('You have not selected any students', 'error');
      return;
    }
    if (!classId)
      return;

    const options =
    {
      id: classId,
      studentIds: selectedStudents.map((item) => item.studentId),
    };
    var response = await addStudentsAPI(options);
    if (response.error) {
      CustomToast(response.error.data.error, 'error');
      return (false);
    }
    CustomToast('Students Added Successfully', 'success');
    navigate(-1);
  };

  const handleMissingStudents = async () => {
    setOpenAdminHelpModal(true);
    if (admins == null)
      await loadAllAdmins();
  };

  const loadAllAdmins = async () => {
    setAdmins(await getAllAdmins(selectedSchoolId).unwrap());
  };

  return (
    <>
      <div className="white-card">
        <div>
          <Row>
            <Col className='d-flex'>
              <div className='primary-title d-flex align-items-end'>
                <span className='fw-medium mr-1'>Add Students to </span> {className && <span className='fw-normal mr-1'>{className}</span>}
              </div>
              <div>
                <OverlayTrigger
                  placement="right"
                  overlay={
                    <Tooltip className="initial-assignment-tooltip">
                      <span>
                        Use this page to add students with accounts to the class. Check the box next to the students&apos; names, then click the &apos;Add&apos; button. If the checkbox is dimmed, that means the student is already in the class. Use the links to scroll through a long list, type the first few letters of a name and click <b>Search</b> to find a particular student, or click a letter to jump ahead.
                        <br /><b>After adding additional students to the class, you may want to review your assignments and access settings, where appropriate. Previously created assignments are not automatically assigned to new students in a class.</b>
                      </span>
                    </Tooltip>
                  }>
                  <FontAwesomeIcon className="circle-question" icon={faCircleQuestion} />
                </OverlayTrigger>
              </div>
            </Col>
            <Col className='d-flex gap-3 flex-column flex-sm-row  justify-content-between justify-content-md-end align-items-center'>
              <button
                onClick={() => navigate(-1)}
                className="btn btn-castleWhite btn-width">
                Back
              </button>
            </Col>
          </Row>
          <Row className='align-items-center mb-4'>
            <Col>
              <label className="form-label">School</label>
              <DropDownSelect
                value={schools}
                selectedId={selectedSchoolId}
                setSelectedId={(id) => handleSchoolChange(id)}
                dropdownId="schoolSelect"
                selectedName={selectedSchoolName}
                setSelectedName={setSelectedSchoolName}
              />
            </Col>
            <Col>
              {categories && categories.length > 0 && <>
                <label className="form-label">Category</label>
                <DropDownSearch
                  value={categories}
                  dropdownId='categorySelect'
                  placeholder='Select Category'
                  handleChange={(e) => handleSelectionChange(e, categories, setCategories)}
                  selectedId={categories.filter(m => m.isChecked).map(m => m.id)}
                  description={true}
                />
              </>
              }
            </Col>
            <Col className='d-flex justify-content-end align-items-center clr-castleRed'>
              <button className='btn btn-link primary-link' onClick={() => handleMissingStudents()} disabled={!selectedSchoolId}>
                <FontAwesomeIcon icon={faUserGraduate} className='mr-1' />
                <span>Request help with missing students</span>
              </button>
            </Col>
          </Row>
          <hr />
          <Row className='mt-4'>
            <Col>
              <input
                type="text"
                className={'form-control'}
                value={searchKey}
                onChange={(e) => { setSearchKey(e.target.value); }}
                placeholder='Search Name/Id'
              />
            </Col>
            <Col className='border rounded-3 align-content-center'>
              <div className="character-filter d-flex align-items-center gap-2 ">
                <span className='mr-3 width-60'>Filter By</span>
                <ButtonGroup>
                  {characters.map((char) => (
                    <Button
                      key={char}
                      onClick={() => handleCharacterClick(char)}
                      className={`search-icon-btn primary-icon-btn mr-1 d-flex flex-row justify-content-center align-items-center ${filterKey === char ? 'border-success' : ''}`}
                    >
                      {char}
                    </Button>
                  ))}
                </ButtonGroup>
              </div>
            </Col>
          </Row>

          <Row className='mt-4'>
            <div className="table-container">
              <Table className='table reportTable'>
                {students ? (
                  <>
                    <thead className='thead-light align-middle thead-fixed'>
                      <tr>
                        <th>
                          <div className="form-check">
                            <input
                              type="checkbox"
                              className="form-check-input"
                              value=""
                              id="assignCheck"
                              name="assignCheck"
                              checked={
                                students.filter((item) => item?.isChecked !== true && !item.existsInClass).length < 1
                              }
                              onChange={handleCheckBoxChange}
                            />
                          </div>
                        </th>
                        <th scope="col" className='fw-medium'>
                          <span className='align-items-center'> <span>Last Name</span> </span>
                        </th>
                        <th scope="col" className='fw-medium'>
                          <span className='align-items-center'><span>First Name</span></span>
                        </th>
                        <th scope="col" className='fw-medium mw-200 transparent-scroll'>
                          <span className='align-items-center'><span>Login</span></span>
                        </th>
                        <th scope="col" className='fw-medium'>
                          <span className='align-items-center'><span>Id</span></span>
                        </th>
                        <th scope="col" className='fw-medium'>
                          <span className='align-items-center'><span>Category</span></span>
                        </th>
                      </tr>
                    </thead>
                    <tbody>
                      {students?.map((student) => (
                        <tr key={`record_${student.studentId}`}>
                          <td className='d-flex'>
                            {!student.existsInClass && (
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  value=""
                                  name={student.studentId}
                                  checked={student?.isChecked}
                                  onChange={handleCheckBoxChange}
                                  className="form-check-input"
                                  id={`flexCheckDefault-${student.studentId}`}
                                />
                              </div>
                            )}
                            {student.existsInClass && (
                              <div className="form-check">
                                <input
                                  type="checkbox"
                                  value=""
                                  name={student.studentId}
                                  checked={true}
                                  className="form-check-input"
                                  disabled={true}
                                  id={`flexCheckDefault-${student.studentId}`}
                                />
                              </div>
                            )}
                          </td>
                          <td>{student.lName}</td>
                          <td>{student.fName}</td>
                          <td className='mw-200 transparent-scroll overflow-auto'>{student.login}</td>
                          <td>{student.identification}</td>
                          <td>{student.code}</td>
                        </tr>
                      ))}
                      {students?.length == 0 && <tr>
                        <td colSpan='5' className='p-3 text-danger'>There are no students matching the selected search criteria.</td>
                      </tr>}
                    </tbody>
                  </>
                ) : (
                  <>
                    <TableSkeleton
                      colCount={6}
                      rowCount={4}
                    />
                  </>
                )}
              </Table>
            </div>
          </Row>

          <div className="floating-menu-space"></div>
          <div className="floating-menu floating-menu-contained">
            <AddStudentFloatingBar key={'floatingBar'} selectedStudents={selectedStudents} handleCheckBoxChange={handleCheckBoxChange} handleAddStudent={handleAddStudent} />
          </div>
        </div>
      </div>


      <Modal
        isOpen={openAdminHelpModal}
        onClose={() => setOpenAdminHelpModal(false)}
        titleName={'Missing Students'}
        contentWidth={'60%'}
      >
        <Container>
          <Row>
            <Col className='mb-3'>
              Below is a list of administrators who are enrollment contacts for your school or district. Please contact one of them to request assistance with having missing students added to your school&apos;s roster.
            </Col>
          </Row>
          <Row>
            {admins && <Table className='table reportTable'>
              <thead className='thead-light align-middle thead-fixed'>
                <tr>
                  <th scope="col" className='fw-medium'>Name</th>
                  <th scope="col" className='fw-medium'>School</th>
                  <th scope="col" className='fw-medium'>Email</th>
                </tr>
              </thead>
              <tbody>
                {admins.map((admin, index) => (
                  <tr key={'admin' + index}>
                    <td>{admin.lName + ' ' + admin.fName}</td><td>{admin.schoolName}</td><td>{admin.email}</td>
                  </tr>
                ))}
              </tbody>
            </Table>
            }
            {!admins &&
              <TableSkeleton colCount={3} rowCount={3}></TableSkeleton>
            }

          </Row>
          <Row className='justify-content-end mt-4'>
            <Col className='col-3 d-flex justify-content-end'>
              <div className='col-5 d-flex'>
                <button className='btn btn-castleGray flex-grow-1'
                  onClick={() => setOpenAdminHelpModal(false)}>
                  Ok
                </button>
              </div>
            </Col>
          </Row>
        </Container>
      </Modal>
    </>
  );
};
export default AddStudents;